import React from 'react';
import { withStyles, styled } from '@material-ui/core/styles';
import {
	Button,
	Dialog,
	DialogTitle as MuiDialogTitle,
	DialogContent as MuiDialogContent,
	DialogActions as MuiDialogActions,
	IconButton,
	Typography,
} from '@material-ui/core';

import { Close as CloseIcon } from '@material-ui/icons';

const PREFIX = 'Preview';

const classes = {
    root: `${PREFIX}-root`,
    root2: `${PREFIX}-root2`,
    root3: `${PREFIX}-root3`,
    closeButton: `${PREFIX}-closeButton`
};

const StyledMuiDialogTitle = styled(MuiDialogTitle)((
    {
        theme
    }
) => ({
    [`& .${classes.root3}`]: {
		margin: 0,
		padding: theme.spacing(2),
	},

    [`& .${classes.closeButton}`]: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	}
}));

/**
 * Component rendered for Previewing Video or images using srcpath taken as prop.
 */
export default function Preview({ srcpath, type, show, handleClose, fileName }) {
	return (
        <div>
			<Dialog
				maxWidth="xl"
				onClose={handleClose}
				aria-labelledby="customized-dialog-title"
				open={show}>
				<DialogTitle id="customized-dialog-title" onClose={handleClose}>
					Preview Window
				</DialogTitle>
				<DialogContent
                    dividers
                    classes={{
                        root: classes.root
                    }}>
					{type === 'video' ? (
						<video controls width="640" height="480" alt={fileName}>
							<source src={srcpath} type="video/mp4" />
						</video>
					) : (
						<img src={srcpath} width="100%" height="100%" alt={fileName} />
					)}
				</DialogContent>
				<DialogActions
                    classes={{
                        root: classes.root2
                    }}>
					<Button autoFocus onClick={handleClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
    );
}

const DialogTitle = ((props) => {
	const { children,  onClose, ...other } = props;
	return (
        <StyledMuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</StyledMuiDialogTitle>
    );
});

const DialogContent = MuiDialogContent;

const DialogActions = MuiDialogActions;
